import { Button } from "@/components/ui/Button"
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/Dialog"

interface ErrorDialogProps {
  title?: string
  message: string
  onClose: () => void
}

export function ErrorDialog({ title, message, onClose }: ErrorDialogProps) {
  return (
    <Dialog
      open={true}
      onOpenChange={(isOpen: boolean) => !isOpen && onClose()}
    >
      <DialogContent className="tw-max-w-lg tw-font-sansAlt">
        <DialogHeader>
          <DialogTitle className="tw-text-red-600">
            {title || "Error"}
          </DialogTitle>
        </DialogHeader>
        <div className="tw-py-4">
          <p className="tw-text-sm tw-text-gray-600">{message}</p>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>
            Close
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
